'use strict';
import {epics as onDeleteEpicEpics} from './onDeleteEpic';
import {navigationUtilityEpics} from './onNavBlockClicks';
import {epics as onShowHideNotificationPanelEpics} from './onShowHideNotificationPanel';


export const epics = [
  ...onDeleteEpicEpics,
  ...navigationUtilityEpics,
  ...onShowHideNotificationPanelEpics,
];



// WEBPACK FOOTER //
// ./src/js/system/epics/index.js